/* eslint-disable */

import 'babel-polyfill';
import './polyfills/querySelectorAll';
import React, { Component } from 'react';
import * as Scroll from 'react-scroll';
import './App.css';
import Header from './components/header';
import Landing from './components/landing';
import VehicleNav from './components/vehicleNav';
import SearchTabs from './components/searchTabs';
import Results from './components/results/results';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';
import store from './store';
import ReactGA from 'react-ga';
import { parse } from 'qs';

const Fragment = React.Fragment;
const language = store.getState().content.language;

class App extends Component {
  constructor(props) {
    super(props);
    const { location, i18n, t } = this.props;
    if (language == 'ru') {      
      window.location.href = 'https://productselector.eame.mobil.com/'
    }
    
    if (['is', 'fr-be', 'nl-be'].indexOf(i18n.language) === -1) {
      i18n.changeLanguage(this.props.location.pathname.replace('/', ''));
    }

  }

  state = {};

  componentDidMount() {
    Scroll.animateScroll.scrollToTop();
  }

  componentDidUpdate(prevProps) {

    if (this.state.selectedTabId) {
      const id = this.state.selectedTabId;
      if (!this.state.equipment) {
        ReactGA.event({
          category: this.props.i18n.language,
          action: id.charAt(0).toUpperCase() + id.slice(1),
        });
      }

      if (!this.state.trackedSearch) {
        this.setState({ trackedSearch: true });
        Scroll.animateScroll.scrollToTop();
        ReactGA.pageview('search');
        ReactGA.event({ category: 'Landing', action: 'B2B' });
      }
    }

    if (this.state.equipment) {
      if (!this.state.trackedResults) {
        this.setState({ trackedResults: true });
        window.scrollTo(0, 0);
        ReactGA.pageview('results');
      }
    }
  }

  backToSearch = (selectedFamily, isSearchOnly) => {
    this.setState({
      equipment: null,
      selectedFamily: selectedFamily,
      isSearchOnly: isSearchOnly,
    });
  };

  getData = (data) => {
    this.setState(data);
  };

  updateHeader = (value) => {
    this.setState({ header: value });
  };

  render() {
    const landing = (
      <section className="App">
        <Landing showMainApp={this.getData} />
      </section>
    );

    const search = (
      <Fragment>
        <VehicleNav
          updateHeader={this.updateHeader}
          searchOnly={this.getData}
          selectedFamily={this.getData}
          currentFamily={this.state.selectedFamily}
          isSearchOnly={this.state.isSearchOnly}
        />
        <SearchTabs
          equipment={this.getData}
          searchOnly={this.state.searchOnly}
          selectedFamily={this.state.selectedTabId}
          isSearchOnly={this.state.isSearchOnly}
        />
      </Fragment>
    );

    const results = (
      <Results
        updateHeader={this.updateHeader}
        backToSearch={this.backToSearch}
        equipment={this.state.equipment}
        cvl={this.state.searchOnly}
        selectedFamily={this.state.selectedTabId}
      />
    );

    const mainApp = (
      <section className="App">
        <Header header={this.state.header} selectedFamily={this.state.selectedTabId} />
        {this.state.equipment ? results : search}
      </section>
    );

    return this.state.showMainApp ? mainApp : landing;
  }
}

export default withRouter(translate('translations')(withRouter(App)));



// WEBPACK FOOTER //
// ./src/App.js